export const Packages = {
  state: {
    basicPackage: [],
  },

  getters: {
    basicPackage(state) {
      return state.basicPackage;
    },
  },

  mutations: {
    setBasic(state, basicPackage) {
      state.basicPackage = basicPackage;
    },
  },

  actions: {
    setBasic({ commit }) {
      return this._vm
        .$api('basic.package', ['1.0'])
        .then((response) => {
          const basicPackage = response.data.data;
          commit('setBasic', basicPackage);
        })
        .catch(() => {})
        .finally();
    },
  },
};
